
























// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
import TheFormCategories from '@/components/categories/TheFormCategories.vue';
// Importing functions
import {validateCategory} from '@/ts/categories/validate-category';
import {postCategory} from '@/ts/categories/post-category';

export default {
    name: 'PageCategoriesCreate',
    components: {
        LayoutApp,
        BaseCard,
        BaseAlertList,
        TheFormCategories,
    },
    props: {},
    data() {
        return {
            data: Object(),
            errors: Array(),
            items: Array(),
            first_page: Boolean(true),
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateCategory(this.errors, this.data);

            if (this.errors.length === 0) {
                postCategory(this.data, this.$route.params.id).then(() => {
                    this.$router.push({ name: 'categories', params: { id: this.$route.params.id} });
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Категории',
            to: { name: 'categories', params: { id: this.$route.params.id} },
        }, {
            text: 'Създаване',
        }];
        // Initializing the user data object
        this.data = {
            name: '',
            description: '',
            is_active: '1',
        };
        this.$store.dispatch('setLoadingOff');
    },
};
